import React from 'react';
import { trustBadges } from '../data/content';
export function TrustBadges() {
  return <section aria-label="Why homeowners call us" className="w-full border-b border-forest-100 bg-white" data-id="element-373" data-mp="2oihurfnf2x02">
      <ul className="mx-auto grid max-w-6xl px-0 sm:grid-cols-3" data-id="element-374" data-mp="32iiuusvuy0eh">
        {trustBadges.map(({
        icon: Icon,
        title,
        body
      }) => <li key={title} className="flex items-start gap-4 border-b border-forest-100 px-5 py-5 last:border-0 sm:border-b-0 sm:border-r sm:last:border-r-0" data-id="element-375" data-mp="2xhldgiio9ae1">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-forest-50" data-id="element-376" data-mp="37hvs87kcupvb">
              <Icon className="h-5 w-5 text-ember-600" aria-hidden="true" data-id="element-377" data-mp="3l8qw15fzygs1" />
            </span>
            <div data-id="element-378" data-mp="3h6ngo5q7is1h">
              <p className="font-display text-lg uppercase leading-tight text-forest-800" data-id="element-379" data-mp="3h86ulpoe4r03">
                {title}
              </p>
              <p className="mt-0.5 text-sm text-ink-700" data-id="element-380" data-mp="3v4kawvh6umcz">{body}</p>
            </div>
          </li>)}
      </ul>
    </section>;
}